export const navbarTranslations = {
  es: {
    about: "Sobre mí",
    experience: "Experiencia",
    education: "Educación",
    skills: "Habilidades",
    projects: "Proyectos",
    contact: "Contacto",
  },
  en: {
    about: "About",
    experience: "Experience",
    education: "Education",
    skills: "Skills",
    projects: "Projects",
    contact: "Contact",
  },
  ca: {
    about: "Sobre mi",
    experience: "Experiència",
    education: "Formació",
    skills: "Competències",
    projects: "Projectes",
    contact: "Contacte",
  },
};
